import { useAppSelector } from '@src/core/hooks';
import { useWidgetId } from '@src/core/IdProvider';
import useSelectedProductId from '@src/hooks/useSelectedProductId';
import { upsellBookingProductsSelector } from '@src/stores/productUpsell';
import { multiProductBookingSelector, multiProductBookingTotalCentsSelector } from '@src/stores/multiProductBooking';
import { useUpsellBookingEventTrack } from './useUpsellBookingEventTrack';

export const useUpsellBooking = () => {
  const widgetId = useWidgetId();
  const products = useAppSelector(upsellBookingProductsSelector);
  const totalCents = (useAppSelector(multiProductBookingTotalCentsSelector(widgetId)) as number) ?? 0;
  const booking = useAppSelector(multiProductBookingSelector);
  const selectedProductId = useSelectedProductId();

  useUpsellBookingEventTrack({ booking, selectedProductId });

  return { products, totalCents };
};
